(function () {
  var FORM_SELECTOR = 'form[data-type="add-to-cart-form"]'

  function getVisibleCustomInputs(form) {
    return Array.from(form.querySelectorAll('input[type="text"][name^="properties["]')).filter(function (input) {
      var el = input
      while (el && el !== form) {
        if (el.style && el.style.display === 'none') return false
        el = el.parentElement
      }
      return true
    })
  }

  // retryEl: the Shop Pay button to re-click after "Continue with no text" (null = Add to Cart)
  function showWarning(form, emptyInputs, retryEl) {
    var existing = form.querySelector('.custom-text-warning')
    if (existing) existing.remove()

    var warningEl = document.createElement('div')
    warningEl.className = 'custom-text-warning'
    warningEl.style.cssText =
      'background:#fff8e6;border:2px solid #e0a800;border-radius:6px;padding:14px 16px;margin-bottom:14px;'
    warningEl.innerHTML =
      '<p style="margin:0 0 6px;font-weight:700;font-size:1em;">&#9888;&#65039; Some text fields are empty</p>' +
      '<p style="margin:0 0 12px;font-size:0.9em;line-height:1.5;">Did you mean to leave them blank? If so, click <strong>&ldquo;Continue with no text&rdquo;</strong> to confirm. Otherwise, please fill in your custom text below.</p>' +
      '<div style="display:flex;gap:10px;flex-wrap:wrap;">' +
      '<button type="button" class="btn btn--secondary" data-warning-fill>Fill in my text</button>' +
      '<button type="button" class="btn" data-warning-confirm>Continue with no text</button>' +
      '</div>'

    var submitWrapper = form.querySelector('.add-to-cart').closest('div')
    submitWrapper.parentNode.insertBefore(warningEl, submitWrapper)

    warningEl.querySelector('[data-warning-fill]').addEventListener('click', function () {
      warningEl.remove()
      emptyInputs[0].focus()
      emptyInputs[0].scrollIntoView({ behavior: 'smooth', block: 'center' })
    })

    warningEl.querySelector('[data-warning-confirm]').addEventListener('click', function () {
      emptyInputs.forEach(function (input) {
        input.value = 'No Custom Text'
      })
      warningEl.remove()
      if (retryEl) {
        // Fields now hold "No Custom Text", so the Shop Pay check passes on its own.
        // If Shop Pay ignores this scripted click, the customer can simply click it again.
        retryEl.click()
        return
      }
      form.dataset.skipEmptyCheck = 'true'
      form.querySelector('.add-to-cart').click()
    })
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target
      if (!form.matches || !form.matches(FORM_SELECTOR)) return

      if (form.dataset.skipEmptyCheck === 'true') {
        delete form.dataset.skipEmptyCheck
        return
      }

      var emptyInputs = getVisibleCustomInputs(form).filter(function (input) {
        return input.value.trim() === ''
      })

      if (emptyInputs.length > 0) {
        e.preventDefault()
        e.stopImmediatePropagation()
        showWarning(form, emptyInputs, e.shopPayTarget || null)
      }
    },
    true
  )

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target.closest || !e.target.closest('.shopify-payment-button')) return
      var form = e.target.closest(FORM_SELECTOR)
      if (!form) return

      var probe = new Event('submit', { cancelable: true })
      probe.shopPayTarget = e.composedPath()[0]

      if (!form.reportValidity() || !form.dispatchEvent(probe)) {
        e.preventDefault()
        e.stopPropagation()
        e.stopImmediatePropagation()
      }
    },
    true
  )
})()
